import { configureStore } from "@reduxjs/toolkit";
import createSagaMiddleware from "redux-saga";
import rootSaga from "./rootSaga";

import menuReducer from "./slices/menuSlice";
import bankListReducer from "./slices/bankListSlice";
import testimonialReducer from "./slices/testimonialSlice";
import faqReducer from "./slices/faqSlice";
import herosliderReducer from "./slices/herosliderSlice";
import festivalReducer from "./slices/festivalSlice";
import loanProductReducer from "./slices/loanProductSlice";
import subServiceReducer from "./slices/subServiceSlice";
import loanDetailsReducer from "./slices/loanDetailsSlice";
import satisfiedCounterReducer from "./slices/satisfiedCounter";
import toastReducer from "./slices/toastSlice";
import teamReducer from "./slices/teamSlice";
import enquiryFormReducer from "./slices/enquiryFormSlice";
import dsaReducer from "./slices/dsaSlice";
import leadReducer from "./slices/leadSlice";
import helpServiceReducer from "./slices/helpServiceSlice";
import instantServiceReducer from "./slices/instantServiceSlice";
import instantServicesListReducer from "./slices/instantServicesListSlice";
import servicesReducer from "./slices/servicesSlice";

const sagaMiddleware = createSagaMiddleware();

export const store = configureStore({
  reducer: {
    menu: menuReducer,
    bankList: bankListReducer,
    testimonial: testimonialReducer,
    faq: faqReducer,
    heroslider: herosliderReducer,
    festival: festivalReducer,
    loanProduct: loanProductReducer,
    subService: subServiceReducer,
    loanDetails: loanDetailsReducer,
    satisfiedCounter: satisfiedCounterReducer,
    toast: toastReducer,
    team: teamReducer,
    enquiryForm: enquiryFormReducer,
    dsa: dsaReducer,
    lead: leadReducer,
    helpService: helpServiceReducer,
    instantService: instantServiceReducer,
    instantServicesList: instantServicesListReducer,
    services: servicesReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({ thunk: false }).concat(sagaMiddleware),
});

sagaMiddleware.run(rootSaga);
